module.exports = __webpack_public_path__ + "static/media/Hospitality_64.7270cdd9.jpg";